import { render, staticRenderFns } from "./OrderDialog.vue?vue&type=template&id=5db7d670&"
import script from "./OrderDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports